package com.havn.app.features.clients.domain

data class Client(
    val id: String,
    val agentId: String,
    val firstName: String? = null,
    val lastName: String? = null,
    val fullName: String,
    val email: String? = null,
    val phone: String? = null,
    val qrToken: String,
    val walletPassKey: String,
    val passIdentityId: String? = null,
    val notes: String? = null,
    val avatarDataUrl: String? = null,
    val avatarStoragePath: String? = null,
    val avatarThumbnailDataUrl: String? = null,
    val avatarThumbnailStoragePath: String? = null,
    val qrCodeUrl: String? = null,
    val qrCodeStoragePath: String? = null,
    val walletPassUrl: String? = null,
    val walletPassStoragePath: String? = null,
    val avatarContentType: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val openings: List<ClientOpening> = emptyList(),
    val inquiries: List<ClientInquiry> = emptyList()
) {
    val contactLine: String
        get() = listOfNotNull(phone?.takeIf { it.isNotBlank() }, email?.takeIf { it.isNotBlank() })
            .joinToString(" · ")
            .ifBlank { "No contact captured" }

    val qrPayload: String
        get() = HavnClientQrPayload.forClient(id, walletPassKey, passIdentityId).encode()
}

data class ClientQrDeliveryAssets(
    val client: Client,
    val qrCodeUrl: String,
    val walletPassUrl: String? = null
)

data class ClientDraft(
    val firstName: String,
    val lastName: String,
    val email: String? = null,
    val phone: String? = null,
    val notes: String? = null
) {
    val fullName: String
        get() = listOf(firstName, lastName).joinToString(" ").trim()
}

data class ClientOpening(
    val leadId: String,
    val openingId: String,
    val propertyId: String?,
    val propertyTitle: String,
    val propertyAddress: String,
    val propertyPhotoDataUrl: String? = null,
    val openingTitle: String?,
    val startsAt: String,
    val status: String,
    val temperature: String
) {
    val displayTitle: String
        get() = openingTitle?.takeIf { it.isNotBlank() } ?: propertyTitle
}

data class ClientInquiry(
    val leadId: String,
    val propertyId: String?,
    val propertyTitle: String,
    val propertyAddress: String,
    val temperature: String,
    val createdAt: String? = null,
    val desiredLocation: String? = null,
    val locationRadiusKm: Int? = null,
    val budgetMin: Long? = null,
    val budgetMax: Long? = null,
    val purchaseTimeline: String? = null,
    val desiredPropertyType: String? = null
    ,val notes: String? = null
    ,val source: String? = null
)
